module.exports = __webpack_public_path__ + "img/Logo_CleverLAB.ee1fd44c.png";